import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'core-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.css']
})
export class PagerComponent implements OnInit {


  private _skip: number;
  private _take: number;
  private _totalCount: number;
  public itemsShown: number;
  public currentPage: number;
  public totalPages: number;
  public blockSizeMax = 10;
  public blocks: number[];
  public isInitialized = false;

  @Input()
  set skip(value: number) {
    this._skip = value;

    this.init();

    if (this.totalCount > 0 && this.take > 0) {
      this.calcBlock();
    }

  }
  get skip(): number { return this._skip; }

  @Input()
  set take(value: number) {

    this._take = value;
    this.init();

    if (this.totalCount > 0 && this.take > 0) {
      this.calcBlock();
    }
  }
  get take(): number { return this._take; }

  @Input()
  set totalCount(value: number) {

    if (value !== this._totalCount) {
      this.blocks = [];
    }

    this._totalCount = value;
    this.init();

    if (this.totalCount > 0 && this.take > 0) {
      this.calcBlock();
    }
  }
  get totalCount(): number { return this._totalCount; }

  @Output()
  public navigate = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  public first() {
    this.goto(1);
  }

  public last() {
    this.goto(this.totalPages);
  }

  public next() {
    if (this.currentPage === this.totalPages) { return; }
    this.goto(this.currentPage + 1);
  }

  public previous() {
    if (this.currentPage === 0) { return; }
    this.goto(this.currentPage - 1);
  }

  public goto(page: number) {
    this.navigate.emit(page);
  }

  init() {
    if (this.take === undefined || this.take === 0 || this.totalCount === undefined) {

      this.itemsShown = this.totalCount;
      this.totalPages = 1;
      this.currentPage = 1;

    } else {

      this.totalPages = Math.floor(this.totalCount / this.take) + (this.totalCount % this.take > 0 ? 1 : 0);
      this.currentPage = this.skip / this.take + 1;
      this.itemsShown = this.take > this.totalCount ? this.totalCount : this.take;
    }

  }

  calcBlock() {

    if (this.blocks == null) {
      this.blocks = [];
    }

    let found = _.find(this.blocks, (n: number) => n === this.currentPage);

    if (!found) {

      this.blocks = [];

      if (this.blocks.length == 0) {

        if (this.totalPages < this.blockSizeMax) {
          for (let i = 1; i <= this.totalPages; i++) {
            this.blocks.push(i);
          }

        }
        else {

          if (this.currentPage + this.blockSizeMax > this.totalPages) {
            for (let i = this.totalPages - this.blockSizeMax; i <= this.totalPages; i++) {
              this.blocks.push(i);
            }
          }
          else {
            for (let i = this.currentPage; i <= this.currentPage + this.blockSizeMax - 1; i++) {
              this.blocks.push(i);
            }
          }

        }
      }
      else {
        let direction = (this.currentPage < this.blocks[0]) ? 'left' : 'right';

        if (direction === 'left') {
          for (let i = this.currentPage; i <= Math.min(this.currentPage + this.blockSizeMax - 1, this.totalPages); i++) {
            this.blocks.push(i);
          }
        }
        else {
          for (let i = Math.max(this.currentPage - this.blockSizeMax + 1, 1); i <= this.currentPage; i++) {
            this.blocks.push(i);
          }
        }

      }

    }

  }

}
